import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'table-header',
    templateUrl: './table.header.component.html',
    styleUrls: ['./table.header.component.scss']
})
export class TableHeaderComponent implements OnInit {

    @Input('Title') Title: string;
    @Input('SearchPlaceholder') SearchPlaceholder: string;
    @Input('HasFilters') HasFilters: boolean;
    @Input('CanExport') CanExport: boolean;

	@Input('FilterString') FilterString: string;
	@Output() FilterStringChange: EventEmitter<string> = new EventEmitter<string>();

    @Output('onRefresh') onRefresh: EventEmitter<boolean> = new EventEmitter();
    @Output('onFilterChange') onFilterChange: EventEmitter<string> = new EventEmitter();
    @Output('onSearch') onSearch: EventEmitter<string> = new EventEmitter();
    @Output('onExport') onExport: EventEmitter<boolean> = new EventEmitter();

    SearchTerm: string = '';
    ShowFilters: boolean = false;

    constructor() { }

    ngOnInit() {

    }

    Refresh() {
        this.onRefresh.emit(true);
    }

    Search(term) {
		this.onSearch.emit(term);
		this.FilterStringChange.emit(term);
	}
	
	

    Export() {
        this.onExport.emit(true);
    }

}
